import React, { useState, useEffect } from 'react';

const CircularProgress = ({ size = 150, strokeWidth = 10, percentage = 0 }) => {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const progress = percentage / 100;
    const circumference = 2 * Math.PI * (size / 2 - strokeWidth / 2);
    const offsetValue = circumference * (1 - progress);

    setOffset(offsetValue);
  }, [percentage, size, strokeWidth]);

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {/* Background ring */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={size / 2 - strokeWidth / 2}
        fill="none"
        stroke="#ccc"
        strokeWidth={strokeWidth}
      />

      {/* Dynamic progress ring with rounded edges */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={size / 2 - strokeWidth / 2}
        fill="none"
        stroke="#68FF77"
        strokeWidth={strokeWidth}
        strokeDasharray={2 * Math.PI * (size / 2 - strokeWidth / 2)}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(90 ${size / 2} ${size / 2})`} // Rotate by 90 degrees
      />
    </svg>
  );
};

export default CircularProgress;
